import React from "react";
import { Box, Card } from "@curves/ui-base";
import { useSmartFitnessContext } from "@icoach/smartFitnessBand/components/SmartFitnessContext";
import { Grid } from "@mui/material";
import { parseCardExpiry, formatCurrencyFn } from "@util/utils";
import { parseDate } from "@util/moment";

const SmartFitnessBandContractDetailSummaryPanel = () => {
	const { contractDetailSourceData } = useSmartFitnessContext();
	const { deviceOrderNo, subscriptionStartDate, monthFee, payment, reviewStartDate, debitDayOfMonth, updatedDate, deviceOrderStatusText } = contractDetailSourceData;
	const { cardExpiryDate } = payment;

	return (
		<Card className={"mb-3 px-4 pt-3 pb-2"}>
			<Card.CardContent>
				<Grid spacing={2} container>
					<Grid className={"mb-1"} xs={6} lg={4} xl={3} item>
						<Grid spacing={2} container>
							<Grid xs={5} item>
								<Box className={"font-color-3"}>主單編號</Box>
							</Grid>
							<Grid xs={7} item>
								<Box>{deviceOrderNo}</Box>
							</Grid>
						</Grid>
					</Grid>
					<Grid className={"mb-1"} xs={6} lg={4} xl={3} item>
						<Grid spacing={2} container>
							<Grid xs={5} item>
								<Box className={"font-color-3"}>訂閱狀態</Box>
							</Grid>
							<Grid xs={7} item>
								<Box>{deviceOrderStatusText}</Box>
							</Grid>
						</Grid>
					</Grid>
					<Grid className={"mb-1"} xs={6} lg={4} xl={3} item>
						<Grid spacing={2} container>
							<Grid xs={5} item>
								<Box className={"font-color-3"}>設備開通日</Box>
							</Grid>
							<Grid xs={7} item>
								<Box>{parseDate(reviewStartDate)}</Box>
							</Grid>
						</Grid>
					</Grid>
					<Grid className={"mb-1"} xs={6} lg={4} xl={3} item>
						<Grid spacing={2} container>
							<Grid xs={5} item>
								<Box className={"font-color-3"}>訂閱起始日</Box>
							</Grid>
							<Grid xs={7} item>
								<Box>{parseDate(subscriptionStartDate)}</Box>
							</Grid>
						</Grid>
					</Grid>
					<Grid className={"mb-1"} xs={6} lg={4} xl={3} item>
						<Grid spacing={2} container>
							<Grid xs={5} item>
								<Box className={"font-color-3"}>更新日期</Box>
							</Grid>
							<Grid xs={7} item>
								<Box>{parseDate(updatedDate)}</Box>
							</Grid>
						</Grid>
					</Grid>
					<Grid className={"mb-1"} xs={6} lg={4} xl={3} item>
						<Grid spacing={2} container>
							<Grid xs={5} item>
								<Box className={"font-color-3"}>扣款日期</Box>
							</Grid>
							<Grid xs={7} item>
								<Box>每月{debitDayOfMonth}日</Box>
							</Grid>
						</Grid>
					</Grid>
					<Grid className={"mb-1"} xs={6} lg={4} xl={3} item>
						<Grid spacing={2} container>
							<Grid xs={5} item>
								<Box className={"font-color-3"}>訂閱月費</Box>
							</Grid>
							<Grid xs={7} item>
								<Box>{formatCurrencyFn(monthFee, { symbol: "$" })}</Box>
							</Grid>
						</Grid>
					</Grid>
					<Grid className={"mb-1"} xs={6} lg={4} xl={3} item>
						<Grid spacing={2} container>
							<Grid xs={5} item>
								<Box className={"font-color-3"}>信用卡效期</Box>
							</Grid>
							<Grid xs={7} item>
								<Box>{parseCardExpiry(cardExpiryDate)}</Box>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Card.CardContent>
		</Card>
	);
};

export default SmartFitnessBandContractDetailSummaryPanel;
